export const getFilesFromTransfer = (
  dt: DataTransfer | null | undefined,
): File[] => {
  if (!dt) return [];

  if (dt.items && dt.items.length > 0) {
    return Array.from(dt.items)
      .filter(item => item.kind === 'file')
      .map(item => item.getAsFile())
      .filter((f): f is File => f != null);
  }

  return dt.files ? Array.from(dt.files) : [];
};

export const transferHasFiles = (
  dt: DataTransfer | null | undefined,
): boolean => !!dt && Array.from(dt.types || []).includes('Files');
